// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BottomMark_wrapper__TxXo1"};